<template>
  <div>
    <div class="cookies-banner" v-if="displayBanner">
      <div class="">
        Des cookies sont utilisés afin d'améliorer l'expérience des utilisateurs du site web du Basket Olympique Puechen.
        En poursuivant votre navigation sur le site, vous acceptez l'utilisation de ces cookies.
        <v-btn outline color="#ffB400" @click="onFollowMore">En savoir plus</v-btn>
        <v-btn outline color="#ffB400" @click="onUnderstand">J'ai compris</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import {CookiesHelper} from "../../../helpers/cookies-helper.js"

export default {
  data() {
    return {
      // gestion geenral de l'affichage
      displayBanner: true,
    };
  },
  mounted() {
    this.$nextTick(function() {
      this.readCookies();
    })
  },
  methods: {
    onUnderstand() {
      CookiesHelper.writeBannerAccepted(true);
      this.readCookies();
    },
    onFollowMore () {
      this.$router.push({name: "cookies"});
    },
    readCookies() {
      this.displayBanner = (CookiesHelper.readBannerState() == false);
    }
  }
}
</script>

<style lang="scss">
.cookies-banner {
  position: fixed;
  z-index: 1000;
  bottom: 0;
  right: 0;
  left: 0;
  padding: 4rem 4rem;
  background-color: #2A2A2A;
  color: #f4f4f4;
}
</style>




// WEBPACK FOOTER //
// src/components/pages/shared/CookiesBanner.vue